/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cute_Pink_Crow_ReviveInputs */

const fr_cute_pink_crow_revive = /** @type {(inputs: Cute_Pink_Crow_ReviveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir comme PR actuel`)
};

/**

* @param {Cute_Pink_Crow_ReviveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cute_pink_crow_revive = /** @type {((inputs?: Cute_Pink_Crow_ReviveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cute_Pink_Crow_ReviveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cute_pink_crow_revive(inputs)
});